import enUS from './en-US'

export default {
  ...enUS,
  message: {
    greeting: 'good day, {name}'
  }
}
